// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/enums/AgeDivisionPt.proto

/* eslint-disable */

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/**
 * 연령 부문 (부)
 *
 * 종목마다 쓰는 부가 다르다.
 *   - 아마추어복싱: 초등부 / 성인부
 *   - IMMAF 종합격투기: 초등부(유스C 12~13세) / 중등부(유스B 14~15세) / 고등부(유스A 16~17세) / 성인부
 *   - 무에타이 · 킥복싱: 초등부 / 중·고·일반부(통합)
 *   - 프로 MMA: 성인부
 *   - 닭싸움: 초등부 저학년 / 초등부 고학년 / 중등부 / 고등부 / 성인부
 */
export enum AgeDivisionPayload {
  AGE_DIVISION_UNKNOWN = 0,
  /** AGE_DIVISION_ELEMENTARY_LOWER - 초등부 저학년 (1 · 2 · 3학년) */
  AGE_DIVISION_ELEMENTARY_LOWER = 1,
  /** AGE_DIVISION_ELEMENTARY_UPPER - 초등부 고학년 (4 · 5 · 6학년) */
  AGE_DIVISION_ELEMENTARY_UPPER = 2,
  /** AGE_DIVISION_ELEMENTARY - 초등부 (학년 구분이 없는 종목용) */
  AGE_DIVISION_ELEMENTARY = 3,
  /** AGE_DIVISION_MIDDLE_SCHOOL - 중등부 */
  AGE_DIVISION_MIDDLE_SCHOOL = 4,
  /** AGE_DIVISION_HIGH_SCHOOL - 고등부 */
  AGE_DIVISION_HIGH_SCHOOL = 5,
  /** AGE_DIVISION_ADULT - 성인부 (일반부) */
  AGE_DIVISION_ADULT = 6,
  UNRECOGNIZED = -1,
}

export function ageDivisionPayloadFromJSON(object: any): AgeDivisionPayload {
  switch (object) {
    case 0:
    case "AGE_DIVISION_UNKNOWN":
      return AgeDivisionPayload.AGE_DIVISION_UNKNOWN;
    case 1:
    case "AGE_DIVISION_ELEMENTARY_LOWER":
      return AgeDivisionPayload.AGE_DIVISION_ELEMENTARY_LOWER;
    case 2:
    case "AGE_DIVISION_ELEMENTARY_UPPER":
      return AgeDivisionPayload.AGE_DIVISION_ELEMENTARY_UPPER;
    case 3:
    case "AGE_DIVISION_ELEMENTARY":
      return AgeDivisionPayload.AGE_DIVISION_ELEMENTARY;
    case 4:
    case "AGE_DIVISION_MIDDLE_SCHOOL":
      return AgeDivisionPayload.AGE_DIVISION_MIDDLE_SCHOOL;
    case 5:
    case "AGE_DIVISION_HIGH_SCHOOL":
      return AgeDivisionPayload.AGE_DIVISION_HIGH_SCHOOL;
    case 6:
    case "AGE_DIVISION_ADULT":
      return AgeDivisionPayload.AGE_DIVISION_ADULT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AgeDivisionPayload.UNRECOGNIZED;
  }
}

export function ageDivisionPayloadToJSON(object: AgeDivisionPayload): string {
  switch (object) {
    case AgeDivisionPayload.AGE_DIVISION_UNKNOWN:
      return "AGE_DIVISION_UNKNOWN";
    case AgeDivisionPayload.AGE_DIVISION_ELEMENTARY_LOWER:
      return "AGE_DIVISION_ELEMENTARY_LOWER";
    case AgeDivisionPayload.AGE_DIVISION_ELEMENTARY_UPPER:
      return "AGE_DIVISION_ELEMENTARY_UPPER";
    case AgeDivisionPayload.AGE_DIVISION_ELEMENTARY:
      return "AGE_DIVISION_ELEMENTARY";
    case AgeDivisionPayload.AGE_DIVISION_MIDDLE_SCHOOL:
      return "AGE_DIVISION_MIDDLE_SCHOOL";
    case AgeDivisionPayload.AGE_DIVISION_HIGH_SCHOOL:
      return "AGE_DIVISION_HIGH_SCHOOL";
    case AgeDivisionPayload.AGE_DIVISION_ADULT:
      return "AGE_DIVISION_ADULT";
    case AgeDivisionPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
